import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import moment from 'moment'
import _ from "lodash"

Vue.use(Vuex)

export const store = new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
    
    state:{

        attendance:{},
        leavedays:{},
        report:{},
        tasks:{},
        user:{},
        company:{},
        loggedin:false,
        expiry:'',
        token: null,
        departments:{},
        absent:{},
        staff: {}
     
       
    },

    mutations:{

        attendance: (state , payload ) => {
            payload.forEach((value,key)  => {
                let day = moment(value.TrxDate).isoWeekday()
                let weektime = JSON.parse(payload[key]["StaffTask.RecommendedTimeJSON"]).Time.filter((item) => {
                    if(item.WeekDay == day){
                        return item
                    }
                })
                
                Object.assign(payload[key], { 
                    "StaffTask.RecommendedTime":weektime[0].Time.substring(0,5),
                });

                        
            });
            state.attendance = _.sortBy(payload, [function(o) { return o['StaffTask.RecommendedTime']}]).reverse()
        },
        report: (state , payload ) => {

            payload.forEach((value,key)  => {
                let day = moment(value.TrxDate).isoWeekday()
                let weektime = JSON.parse(payload[key]["StaffTask.RecommendedTimeJSON"]).Time.filter((item) => {
                    if(item.WeekDay == day){
                        return item
                    }
                })
                
                Object.assign(payload[key], { 
                    "StaffTask.RecommendedTime":weektime[0].Time.substring(0,5),
                });

                        
            });
            state.report = payload
        },

        staff: (state, payload) => {
            state.staff = payload;
        },

        tasks: (state , payload ) => {
            payload.forEach((value,key)  => {
                
                let weektime = JSON.parse(payload.tasks[key].RecommendedTimeJSON).Time
                weektime.forEach( (key, index) => {
                   
                    weektime[index].Time = weektime[index].Time.substring(0,5)

                })
                
                Object.assign(payload.tasks[key], { 
                    RecommendedTime: weektime
                });

                        
            });

            state.tasks = payload
        },
        absent: (state , payload ) => {
            state.absent = payload
        },
        leavedays: (state , payload ) => {
            state.leavedays = payload
        },
        login: (state , payload ) => {

            payload.tasks.forEach((value,key)  => {
                
                let weektime = JSON.parse(payload.tasks[key].RecommendedTimeJSON).Time
                weektime.forEach( (key, index) => {
                   
                    weektime[index].Time = weektime[index].Time.substring(0,5)

                })
                
                Object.assign(payload.tasks[key], { 
                    RecommendedTime: weektime
                });

                        
            });
            
            state.user = payload.user
            state.loggedin = true
            state.token = payload.token
            state.expiry = payload.expiry
            state.tasks = payload.tasks
            state.departments = payload.departments
            state.company = payload.company
           
        },
        logout: (state) => {
            
            state.user = {}
            state.loggedin = false
            state.token= null,
            state.expiry = ''
            state.attendance = {}
            state.report = {}
            state.tasks = {}
            state.departments = {}
            state.company = {}
            state.staff = {}


        },


    },
    actions:{

            login: (context , payload) => {
                context.commit('login' , payload)
            },
            logout: (context) => {
                context.commit('logout')
            },
            tasks: (context,payload) => {
                context.commit('tasks',payload)
            },
            leavedays: (context,payload) => {
                context.commit('leavedays',payload)
            },

            getAttendance({ commit , state  }) {
                return new Promise(( res, rej ) => {
                    fetch(`https://stats.little.bz/attendance/${state.company.CorporateID}`, 
                    {
                        method:'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization':state.token
                        },
                    
                    })
                    .then(response => response.json())
                    .then(data => {
                        
                            if(data.success){
                                commit('attendance', data.attendance)
                                res();
                            }      
                    })
                    .catch(() => rej())
                })
            },

            getAbsent({ commit , state  }  , payload) {
                return new Promise(( res, rej ) => {
                    fetch(`https://stats.little.bz/attendance/report/absent/${state.company.CorporateID}`, 
                    {
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization':state.token
                        },
                        body:JSON.stringify(payload)
                    
                    })
                    .then(response => response.json())
                    .then(data => {
                        
                            if(data.success){
                                commit('absent', data.absentstaff)
                                res();
                            }      
                    })
                    .catch(() => rej())
                })
            },

            getReport({ commit ,state } , payload) {              
                return new Promise(( res, rej ) => {
                    fetch(`https://stats.little.bz/attendance/report/${state.company.CorporateID}`, 
                    {
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization':state.token
                        },
                        body:JSON.stringify(payload)
                    
                    })
                    .then(response => response.json())
                    .then(data => {
                            if(data.success){
                                commit('report', data.attendance)
                                res();
                            }else{
                                commit('report', [])
                                res();
                            }   
                    })
                })
            },

            getStaff({ commit ,state }) {
    
                return new Promise(( res, rej ) => {
                    fetch(`https://stats.little.bz/attendance/staff/${state.company.CorporateID}`, 
                    {
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization':state.token
                        },
                    
                    })
                    .then(response => response.json())
                    .then(data => {
                            if(data.success){
                                commit('staff', data.staff)
                                res();
                            }else{
                                commit('staff', [])
                                res();
                            }   
                    })
                })
            },

            getTasks({ commit , state  }) {
                return new Promise(( res, rej ) => {
                    fetch(`https://stats.little.bz/attendance/task/${state.company.CorporateID}`, 
                    {
                        method:'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization':state.token
                        },
                        
                    
                    })
                    .then(response => response.json())
                    .then(data => {
                        
                            if(data.success){
                                commit('tasks', data.tasks)
                                res();
                            }      
                    })
                    .catch(() => rej())
                })
            },

            
    }

})